var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9688 8.33203C20.6946 8.33203 22.0938 6.93292 22.0938 5.20703C22.0938 3.48114 20.6946 2.08203 18.9688 2.08203C17.2429 2.08203 15.8438 3.48114 15.8438 5.20703C15.8438 6.93292 17.2429 8.33203 18.9688 8.33203Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46875 15.625C8.19464 15.625 9.59375 14.2259 9.59375 12.5C9.59375 10.7741 8.19464 9.375 6.46875 9.375C4.74286 9.375 3.34375 10.7741 3.34375 12.5C3.34375 14.2259 4.74286 15.625 6.46875 15.625Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9688 22.918C20.6946 22.918 22.0938 21.5189 22.0938 19.793C22.0938 18.0671 20.6946 16.668 18.9688 16.668C17.2429 16.668 15.8438 18.0671 15.8438 19.793C15.8438 21.5189 17.2429 22.918 18.9688 22.918Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16406 14.0742L16.2786 18.2201",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2682 6.78125L9.16406 10.9271",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.47372137917d2aab953ea0c5639f0f65.svg";
export { ForwardRef as ReactComponent };